import { FormControl, FormLabel, Textarea, } from '@chakra-ui/react';
import React from 'react';
import FormFieldErrors from '../FormFieldErrors/FormFieldErrors';
const StandardFormTextArea = ({ label, value, onChange, error, isDisabled = false, ...rest }) => (React.createElement(FormControl, { isInvalid: !!error, isDisabled: isDisabled },
    React.createElement(FormLabel, { "data-testid": "standard_form_text_area__form_label" }, label),
    React.createElement(Textarea, { "data-testid": "standard_form_text_area__input", w: "full", variant: "primary", onChange: onChange, value: value ?? '', ...rest }),
    React.createElement(FormFieldErrors, { errors: error })));
export default StandardFormTextArea;
